<template >

    <input
        class="mobile-input"
        :placeholder="placeholder"
        style="font-family:Arial, FontAwesome"
        :value="content"
        @input='reportInput'
        @keyup="report"
        autocomplete="rut2jfkde"
        type="text" />

</template >

<script >
export default {
  name: "MobileInput",
  props: {
    value: {
      type: [String,
             Number], default: null
    },
    placeholder: {type: String, default: null}
  },
  data() {
    return {
      content: this.value
    }
  },
  watch: {
    value(v, vo) {
      if (v == vo) return
      this.content = v
    }
  },
  methods: {
    reportInput(e) {
      this.content = e.target.value
      if (this.value != this.content)
        this.$emit('input', this.content)
    },
    report() {
      _log_('yellow', this.content)
      this.$emit('input', this.content)
    }
  }
}
</script >

<style scoped >
input.mobile-input {
  width: 100%;
  border-bottom: grey 1px solid;
  color: grey;
  border-left: none;
  border-right: none;
  border-top: none;
}
</style >
